import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import responsiveLayoutPlugin from '@plugins/responsiveLayoutPlugin'
import whiteLabelPlugin from '@plugins/whiteLabelPlugin'
import events from '@plugins/events'

Vue.config.productionTip = false

Vue.use(whiteLabelPlugin, {
  project: 'portal-woliflix',
  cssVariables: true,
  cache: true
})

Vue.use(events)

Vue.use(responsiveLayoutPlugin, {
  xs: { margin: '8px', gutter: '8px' },
  sm: { margin: '16px', gutter: '8px' },
  md: { margin: '64px', gutter: '8px' },
  lg: { margin: '128px', gutter: '8px' },
  xl: { margin: '160px', gutter: '8px' }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
